/* global $ */

import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    $(this.element).inputSpinner({
      groupClass: 'input-spinner-group',
    });
  }

  disconnect() {
    $(this.element).next('div.input-spinner-group').remove();
  }
}
